import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AppConfig {

  private config: Object = null;
  private env: Object = null;

  constructor(private http: HttpClient) {
  }

  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  public getInternalGroupsIdentifier() {
    return this.config["internalGroupsIdentifier"];
  }

  //Use to get ADMIN group
  // public getAdminGroup() {
  //   return this.config['adminGroup']
  // }

  public getRecordsManagementAdminGroup() {
    return this.config['recordsManagementAdminGroup']
  }

  public getRulesAdminGroup() {
    return this.config['ruleManagementAdminGroup']
  }

  public isMetadataDataVersioningEnabled() {
    return this.config['includeMetadataVersion']
  }

  /**
   * Use to get the data found in the first file (env file)
   */
  public getEnv(key: any) {
    return this.env[key];
  }

  /**
   * Function uses to get Access control list for specific group
   * @returns 
   */
  public getACLGroup() {
    return this.config['aclGroup'];
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  public load() {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/env/env.json')
        //.map( res => (res))
        .catch((error: any): any => {
          console.log('Configuration file "env.json" could not be read');
          resolve(true);
          return Observable.throw(error.error || 'Server error');
        })
        .subscribe((envResponse) => {
          this.env = envResponse;
          let request: any = null;

          switch (envResponse['env']) {
            case 'production': {              
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'development': {
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'sit': {
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'uat': {
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'staging': {
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'demo': {
              request = this.http.get('./assets/env/env.' + envResponse['env'] + '.json');
            } break;

            case 'default': {
              console.error('Environment file is not set or invalid');
              resolve(true);
            } break;
          }

          if (request) {
            request
              //.map( res => res )
              .catch((error: any) => {
                console.error('Error reading ' + envResponse['env'] + ' configuration file');
                resolve(error);
                return Observable.throw(error.error || 'Server error');
              })
              .subscribe((responseData: any) => {
                this.config = responseData;
                resolve(true);
              });
          } else {
            console.error('Env config file "env.json" is not valid');
            resolve(true);
          }
        });

    });
  }
}